import type { GiftPassDetail } from '../../api/gift-passes';

import { hasAnyGiftPassAction } from './gift-pass-actions-model';
import { GiftPassActions } from './GiftPassActions';
import { GiftPassDetailBody } from './GiftPassDetailBody';
import { useGiftPassActions } from './use-gift-pass-actions';

export function GiftPassDetailWithActions({
  pass,
  reload,
}: {
  pass: GiftPassDetail;
  reload: () => void;
}) {
  const available = useGiftPassActions(pass);
  return (
    <GiftPassDetailBody
      pass={pass}
      actions={
        hasAnyGiftPassAction(available) ? (
          <GiftPassActions pass={pass} available={available} onChanged={reload} />
        ) : undefined
      }
    />
  );
}
